import { DollarOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useCallback } from "react";

import { useDevice } from "@app/shared/lib/DeviceProvider";
import { useDrawer } from "@app/shared/lib/hooks";
import { Loc } from "@app/shared/ui";

import { WithdrawalForm } from "./WithdrawalForm";

type Props = {
  minAmount?: number;
  onSuccess: () => void;
};

export const Withdrawal: React.FC<Props> = ({ minAmount, onSuccess }) => {
  const device = useDevice();
  const withdrawalModal = useDrawer();

  const handleSuccess = useCallback(() => {
    withdrawalModal.close();
    onSuccess();
  }, [onSuccess, withdrawalModal]);

  return (
    <>
      <Button
        type="primary"
        icon={<DollarOutlined />}
        size={device.deviceSize === "mobile" ? "large" : "middle"}
        className={device.deviceSize === "mobile" ? "w-100" : undefined}
        onClick={withdrawalModal.open}
      >
        <Loc word="Partnership.transaction.withdraw" default="Withdraw" />
      </Button>

      <Modal
        title={
          <Loc word="Partnership.transaction.withdraw" default="Withdraw" />
        }
        open={withdrawalModal.visible}
        destroyOnClose
        width={400}
        onCancel={withdrawalModal.close}
        footer={null}
      >
        <WithdrawalForm
          minAmount={minAmount}
          onCancel={withdrawalModal.close}
          onSuccess={handleSuccess}
        />
      </Modal>
    </>
  );
};
